import React from 'react';
import { motion } from 'framer-motion';
import { Users, GraduationCap, Compass } from 'lucide-react';
const CG_TOOLS = ['Sistemas de Información Geográfica (SIG)', 'Cartografía social', 'Planeación estratégica', 'Formulación de proyectos', 'Veedurías ciudadanas', 'Información catastral para decisiones'];
const PARES_STAGES = [{
  icon: Users,
  title: 'Promotores comunitarios',
  description: 'Aprenden qué es el Catastro Multipropósito, sus beneficios y por qué importa la participación. Sirven de enlace entre comunidades e instituciones.'
}, {
  icon: Compass,
  title: 'Auxiliares de campo',
  description: 'Formación especializada en herramientas técnicas y sociales relacionadas con la recolección de información y el trabajo con las comunidades. Apoyan las labores de construcción del conocimiento territorial y acompañan el desarrollo de las operaciones catastrales.'
}, {
  icon: GraduationCap,
  title: 'Reconocedores prediales',
  description: 'Fortalecimiento de capacidades para participar directamente en los procesos de reconocimiento predial.'
}];
const MUNICIPALITIES = ['El Retorno', 'San José del Guaviare', 'Calamar', 'Mesetas', 'Vista Hermosa', 'Tierralta', 'Montelíbano', 'San José de Uré', 'Puerto Guzmán', 'Puerto Asís', 'Leguízamo', 'Puerto Rico', 'San Vicente del Caguán', 'Solano'];
export function EscuelaIntercultural() {
  return <section id="hito-2" className="py-24 md:py-32 px-4 md:px-8 bg-bone-dark scroll-mt-24" data-id="element-181" data-mp="3tvxfgqalbvom">
      <div className="max-w-[1400px] mx-auto" data-id="element-182" data-mp="3g0lngqntkjbe">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 lg:mb-20" data-id="element-183" data-mp="3kxvjip5prt87">
          <div className="lg:col-span-5" data-id="element-184" data-mp="36y3za6oltglr">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-185" data-mp="36zf1w36bciba">
              Alianzas Clave · Escuelas Interculturales
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-forest leading-[1.05]" data-id="element-186" data-mp="1567ox0e6acsk">
              Escuela Intercultural de Geografía para la Vida-Catastro
              Multipropósito
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3" data-id="element-187" data-mp="2i6avjhxuhhoe">
            <p className="text-lg md:text-xl text-charcoal/85 font-light leading-relaxed mb-5" data-id="element-188" data-mp="2d5etl9x205lm">
              Estrategia de formación desarrollada por el IGAC, en alianza con
              la cooperación alemana (GIZ) y el Banco Mundial, en el marco del
              Plan Nacional de Desarrollo 2022-2026 y financiada con recursos
              públicos, para fortalecer la participación comunitaria en los
              procesos de formación y actualización catastral, así como promover
              la construcción colectiva del conocimiento territorial,
              contribuyendo a consolidar el Catastro Multipropósito como una
              herramienta al servicio de las comunidades y de la gestión
              integral del territorio.
            </p>
            <p className="text-base text-charcoal/70 font-light leading-relaxed" data-id="element-189" data-mp="3klkw16meevk4">
              Trabaja con líderes y lideresas comunitarias, organizaciones
              sociales, autoridades locales, resguardos indígenas, consejos
              comunitarios y juntas de acción comunal —reconociendo las
              diferencias culturales, de género y las particularidades de cada
              territorio—. Su propósito es acercar a las comunidades a la
              información catastral multipropósito y fortalecer la relación
              entre las instituciones y la ciudadanía.
            </p>
          </div>
        </div>

        {/* Pares stages */}
        <div className="mb-16 lg:mb-20" data-id="element-190" data-mp="ev68bqg9ljx9">
          <div className="flex items-end justify-between mb-8" data-id="element-191" data-mp="eu4l6nlz56z6">
            <h3 className="font-serif text-2xl md:text-3xl text-forest" data-id="element-192" data-mp="jnpl4l74ob10">
              Estrategia PAR
            </h3>
            <div className="hidden md:block h-px bg-charcoal/15 flex-grow mx-8" data-id="element-193" data-mp="ooda71bsqhsl" />
            <span className="text-xs uppercase tracking-widest text-charcoal/60 font-medium" data-id="element-194" data-mp="spgp9lm0s9sr">
              Tres etapas
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-195" data-mp="jzzwlxggg22e">
            {PARES_STAGES.map((stage, i) => {
            const Icon = stage.icon;
            return <motion.article key={stage.title} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.5,
              delay: i * 0.1
            }} className="bg-bone p-8 border border-charcoal/10 flex flex-col gap-5 h-full" data-id="element-196" data-mp="fyehe5gg7bp1" data-mpi={i}>
                  <div className="flex items-center justify-between" data-id="element-197" data-mp="b035lp6ler46">
                    <Icon className="text-forest" size={28} strokeWidth={1.5} data-id="element-198" data-mp="ax78u46he8hb" />
                    <span className="font-serif text-clay text-2xl" data-id="element-199" data-mp="5z5pdi55875b">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h4 className="font-serif text-2xl text-forest leading-tight" data-id="element-200" data-mp="1heubk7akp252">
                    {stage.title}
                  </h4>
                  <p className="text-charcoal/75 font-light leading-relaxed text-sm" data-id="element-201" data-mp="2zflki6nxcaaf">
                    {stage.description}
                  </p>
                </motion.article>;
          })}
          </div>
        </div>

        {/* Impact panel */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-0 bg-forest text-bone overflow-hidden" data-id="element-202" data-mp="2vcowg0fm7lz3">
          <div className="lg:col-span-5 relative min-h-[320px] lg:min-h-0" data-id="element-203" data-mp="39bydf2bnak44">
            <img src="https://cdn.magicpatterns.com/uploads/pThwagyMmDVKd3JvAUjsQs/escuelas1.jpg" alt="Jornada de la Escuela Intercultural de Geografía con comunidades e IGAC" className="absolute inset-0 w-full h-full object-cover" data-id="element-204" data-mp="3eajcgyf5uxqz" />
            <span className="absolute bottom-3 right-3 bg-charcoal/55 text-bone/90 text-[10px] font-light px-2 py-1" data-id="element-205" data-mp="aloiw20bpim5">
              Fotografía: IGAC.
            </span>
          </div>
          <div className="lg:col-span-7 p-8 md:p-12 lg:p-14" data-id="element-206" data-mp="fhsj0e72un8k">
            <h3 className="font-serif text-3xl md:text-4xl mt-4 mb-8 leading-tight" data-id="element-207" data-mp="fg93ipt8wg7u">
              Resultados en los municipios TEFOS
            </h3>

            <div className="mb-10 pb-10 border-b border-bone/15" data-id="element-208" data-mp="5j4bwagmrsjn">
              <div className="font-serif text-clay-light text-6xl md:text-7xl leading-none" data-id="element-209" data-mp="1ikhvfrct51q">
                +500
              </div>
              <div className="text-bone/70 text-sm mt-3 font-light max-w-md" data-id="element-210" data-mp="3sw6y6o10iaby">
                Promotores comunitarios y auxiliares de campo capacitados y
                certificados, con potencial de vinculación a las operaciones
                catastrales.
              </div>
            </div>

            <div className="text-xs uppercase tracking-[0.2em] text-bone/60 font-semibold mb-4" data-id="element-211" data-mp="3dywdco2hbs3k">
              14 municipios TEFOS
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-212" data-mp="3a0qbnugi02pi">
              {MUNICIPALITIES.map(m => <span key={m} className="border border-bone/25 px-3 py-1.5 text-xs font-medium text-bone/90" data-id="element-213" data-mp="1pg1zdyjvvaiw">
                  {m}
                </span>)}
            </div>
          </div>
        </motion.div>

        {/* Perspectivas / futuro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-16 lg:mt-20" data-id="element-214" data-mp="23fuppsrhzoqc">
          <div className="lg:col-span-5" data-id="element-215" data-mp="1apcnetyllrdz">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-4" data-id="element-216" data-mp="1fq0e1eix067o">
              Hacia adelante
            </span>
            <h3 className="font-serif text-2xl md:text-3xl text-forest leading-tight" data-id="element-217" data-mp="1kijr8adowzby">
              Ampliar el alcance y fortalecer la participación
            </h3>
          </div>
          <div className="lg:col-span-7 lg:pt-2 text-charcoal/80 font-light leading-relaxed" data-id="element-218" data-mp="rzd0odq8codq">
            <p data-id="element-219" data-mp="3hjsr7h3356kv">
              Actualmente, la estrategia del IGAC ha ampliado su alcance con nuevos módulos de formación para fortalecer la participación de organizaciones indígenas como operadores catastrales. Con el apoyo del Banco Mundial, también se busca acelerar la actualización catastral en zonas remotas y ambientalmente sensibles, promover el uso local de la información territorial y contribuir a la formalización de tierras, la gobernanza ambiental y la consolidación de la paz en regiones históricamente excluidas.
            </p>
          </div>
        </motion.div>

        {/* Comunidades Geográficas */}
        <div className="mt-20 lg:mt-28 pt-16 lg:pt-20 border-t border-charcoal/15" data-id="element-220" data-mp="d401zngyc0sa">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-221" data-mp="93psi0tyas8o">
            <div className="lg:col-span-5" data-id="element-222" data-mp="n40m3bmnakxj">
              <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-223" data-mp="n0uyk0tnzr3x">
                Cerrando el ciclo · 11–14 mayo 2026
              </span>
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-forest leading-[1.05]" data-id="element-224" data-mp="11q7flp4fn5it">
                Comunidades Geográficas: un nuevo paso en la apropiación
                territorial
              </h3>
            </div>
            <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-225" data-mp="wql1ldgs5l8y">
              <p className="text-lg md:text-xl text-charcoal/85" data-id="element-226" data-mp="izg8yvbtxt84">
                Cerrando el ciclo de formación de la Escuela Intercultural nacen
                las Comunidades Geográficas, una estrategia participativa del
                IGAC, apoyada por la cooperación alemana y el Banco Mundial, que
                busca fortalecer la cultura catastral y promover el uso de la
                información geográfica y territorial para el desarrollo de los
                territorios.
              </p>
              <p data-id="element-227" data-mp="42fggpltdu8l">
                Reúne a personas que participaron previamente en la Escuela
                Intercultural y que ahora continúan fortaleciendo sus
                capacidades para aplicar la información catastral en procesos de
                planeación, ordenamiento territorial, gestión ambiental,
                adaptación al cambio climático y seguridad jurídica.
              </p>
            </div>
          </div>

          {/* Imagen Comunidades Geográficas */}
          <motion.figure initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="relative w-full overflow-hidden mb-12 aspect-[16/9] md:aspect-[21/9]" data-id="element-228" data-mp="kz5atpfrclrf">
            <img src="https://cdn.magicpatterns.com/uploads/uczuLQQy9Ksx3CVSQgvLEk/comunidades2.jpg" alt="Jornada de Comunidades Geográficas con líderes y lideresas" className="absolute inset-0 w-full h-full object-cover" data-id="element-229" data-mp="g7x0mr6lswd7" />
            <figcaption className="absolute bottom-3 right-3 bg-charcoal/55 text-bone/90 text-[10px] font-light px-2 py-1" data-id="element-230" data-mp="18opy2kiy256i">
              Fotografía: IGAC.
            </figcaption>
          </motion.figure>

          {/* Herramientas */}
          <div className="mb-12" data-id="element-231" data-mp="2ofidxiey1ik2">
            <div className="text-xs uppercase tracking-[0.2em] text-charcoal/60 font-semibold mb-5" data-id="element-232" data-mp="334euy4yza5wt">
              Herramientas que profundizan
            </div>
            <div className="flex flex-wrap gap-3" data-id="element-233" data-mp="2y6d95ca63shn">
              {CG_TOOLS.map(tool => <span key={tool} className="bg-bone border border-charcoal/10 px-4 py-2 text-sm font-light text-charcoal" data-id="element-234" data-mp="2agsf9ych7atl">
                  {tool}
                </span>)}
            </div>
          </div>

          {/* Municipios 2026 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-bone p-8 md:p-10" data-id="element-235" data-mp="2kbu3mryxg8v4">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-6" data-id="element-236" data-mp="3qt7hjatpn1er">
              <h4 className="font-serif text-2xl md:text-3xl text-forest leading-tight" data-id="element-237" data-mp="1suo4nx1jf4k">
                Líderes y lideresas de 9 municipios
              </h4>
              <span className="text-xs uppercase tracking-widest text-charcoal/60 font-medium" data-id="element-238" data-mp="bq91ufrkxpt6">
                Inicio de implementación · 2026
              </span>
            </div>
            <p className="text-charcoal/80 font-light leading-relaxed text-base md:text-lg mb-8" data-id="element-239" data-mp="gn974ogluoj8">
              Entre el 11 y el 14 de mayo de 2026, se dio inicio a la
              implementación de las Comunidades Geográficas, formando líderes y
              lideresas de 9 municipios (El Dorado, Mapiripán y Vista Hermosa,
              en el Meta; San Juan Nepomuceno, en Bolívar; Toluviejo, en Sucre;
              Mercaderes e Inzá, en el Cauca; Tumaco, en Nariño, y Puerto Rico,
              en el Caquetá).
            </p>
            <p className="text-charcoal/80 font-light leading-relaxed text-base md:text-lg mb-8" data-id="element-240" data-mp="31fb2da7f4cmv">
              Tres de estos municipios son beneficiarios del Pilar 1 del
              Proyecto TEFOS: Vista Hermosa y Mapiripán (Meta) y Puerto Rico
              (Caquetá) (ver mapa).
            </p>

            {/* Mapa + convenciones */}
            <figure data-id="element-241" data-mp="19igvkh68zs0d">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center" data-id="element-242" data-mp="19luwdkz9jt5p">
                <div className="md:col-span-2" data-id="element-243" data-mp="14k5g9qx6opar">
                  <img src="https://cdn.magicpatterns.com/uploads/2prZ6d1iCstgfRfKxgAnNo/Lideres_sanandres.png" alt="Mapa de Colombia, incluido el archipiélago de San Andrés y Providencia, con los municipios de líderes y lideresas y los del Pilar 1 del Proyecto TEFOS" className="w-full h-auto" data-id="element-244" data-mp="zlc5w7d71eet" />
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/kQ5p3B6m5JV7aE4vuzKw71/convencionnueva.jpg" alt="Convenciones del mapa: Municipios TEFOS y Municipios no TEFOS" className="w-full max-w-[260px] h-auto mx-auto" data-id="element-245" data-mp="luyxy50axzph" />
              </div>
              <figcaption className="text-charcoal/55 text-xs font-light leading-relaxed mt-6" data-id="element-246" data-mp="by2w2i4wsbtw">
                Fuente: mapa no oficial elaborado con información del IGAC.
              </figcaption>
            </figure>
          </motion.div>
        </div>
      </div>
    </section>;
}